import { Stack } from 'expo-router';

/**
 * Check-in flow layout
 */
export default function CheckInLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="quick" />
      <Stack.Screen name="[id]" />
    </Stack>
  );
}
